import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { BaseApi } from "../../core/base-api";
import { makeMethod, makeDataMethod } from "../../core/base-api/methods-maker";
import * as Request from "../../entries/common/request";
export var CommentsApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(CommentsApi, _BaseApi);

  var _super = _createSuper(CommentsApi);

  function CommentsApi() {
    _classCallCheck(this, CommentsApi);

    return _super.apply(this, arguments);
  }

  return CommentsApi;
}(BaseApi);
export var createCommentsApiClass = function createCommentsApiClass(options) {
  var CreatedCommentsApi = /*#__PURE__*/function (_CommentsApi) {
    _inherits(CreatedCommentsApi, _CommentsApi);

    var _super2 = _createSuper(CreatedCommentsApi);

    function CreatedCommentsApi() {
      _classCallCheck(this, CreatedCommentsApi);

      return _super2.apply(this, arguments);
    }

    return CreatedCommentsApi;
  }(CommentsApi);

  ;
  /**
   * Show comments
   */

  CreatedCommentsApi.prototype.list = makeMethod({
    method: 'get',
    path: options.basePath + Request.Comments.PartialPaths.List,
    needAuth: true
  });
  /**
   * Add comments
   */

  CreatedCommentsApi.prototype.create = makeDataMethod({
    method: 'post',
    path: options.basePath + Request.Comments.PartialPaths.Create,
    needAuth: true
  });
  /**
   * Show comment and any replies. Should hide children?
   */

  CreatedCommentsApi.prototype.show = makeMethod({
    method: 'get',
    path: options.basePath + Request.Comments.PartialPaths.Delete,
    needAuth: true
  });
  /**
   * Show replies to comment
   */

  CreatedCommentsApi.prototype.listReplies = makeMethod({
    method: 'get',
    path: options.basePath + Request.Comments.PartialPaths.ListReplies,
    needAuth: true
  });
  /**
   * update comment
   */

  CreatedCommentsApi.prototype.update = makeDataMethod({
    method: 'put',
    path: options.basePath + Request.Comments.PartialPaths.Show,
    needAuth: true
  });
  /**
   * delete comment
   */

  CreatedCommentsApi.prototype["delete"] = makeMethod({
    method: 'delete',
    path: options.basePath + Request.Comments.PartialPaths.Update,
    needAuth: true
  });
  /**
   * like a comment
   */

  CreatedCommentsApi.prototype.like = makeDataMethod({
    method: 'put',
    path: options.basePath + Request.Comments.PartialPaths.Like,
    needAuth: true
  });
  /**
   * unlike a comment
   */

  CreatedCommentsApi.prototype.unlike = makeMethod({
    method: 'delete',
    path: options.basePath + Request.Comments.PartialPaths.Unlike,
    needAuth: true
  });
  return CreatedCommentsApi;
};